import { createPopper } from '@popperjs/core';
import bootstrap from 'bootstrap'

import stickyNavbar from './components/sticky-navbar';
import stuckNavbarMenuToggle from './components/stuck-navbar-menu-toggle';
import masonryGrid from './components/masonry-grid';
import passwordVisibilityToggle from './components/password-visibility-toggle';
import fileDropArea from './components/file-drop-area';
import formValidation from './components/form-validation';
// import smoothScroll from './components/smooth-scroll';
import scrollTopButton from './components/scroll-top-button';
import tooltip from './components/tooltip';
import popover from './components/popover';
import toast from './components/toast';
import disableDropdownAutohide from './components/disable-dropdown-autohide';
import carousel from './components/carousel';
import gallery from './components/gallery';
import productGallery from './components/product-gallery';
import imageZoom from './components/image-zoom';
import countdown from './components/countdown';
import charts from './components/charts';
import videoButton from './components/video-button';
import subscriptionForm from './components/subscription-form';
import rangeSlider from './components/range-slider';
import filterList from './components/filter-list';
import dataFilter from './components/data-filter';
import labelUpdate from './components/label-update';
import radioTab from './components/radio-tab';
import creditCard from './components/credit-card';
import masterCheckbox from './components/master-checkbox';


import searchTools from './searchTools'

function initializeTracking() {
	if(typeof _paq !== "undefined") {
	    var elements = document.querySelectorAll("[track]");
	    elements.forEach(function (element) {
	        element.addEventListener("click", function () {
	            var trackData = element.getAttribute("track");
	            if (trackData) {
	                var [category, action, name, label] = trackData.split(",");
	                if (category && action && name) {
	                    // Prépare l'événement Matomo
	                    var event = ['trackEvent', category.trim(), action.trim(), name.trim()];
	                    // Ajoute le libellé si présent
	                    if (label) {
	                        event.push(label.trim());
	                    }

	                    _paq.push(event);
	                    // console.log("Matomo event triggered:", [category.trim(), action.trim(), name.trim()]);
	                } else {
	                    // console.warn("Attribut 'track' mal formé pour l'élément :", element);
	                }
	            }
	        });
	    });
	}
}

// Appeler la fonction pour attacher les écouteurs
initializeTracking();